import React, { useEffect, useState } from 'react';
import { Layout, Card, Row, Col } from 'tea-component';
import './index.scss';
import {connect, useSelector} from 'umi';
import { namespace } from './model';
import DataSource from './components/DataSource';
import PackageEdit from '@/pages/datalab/pages/Multidimensional/Extraction/PackageEdit/PackageEdit';
import {useDblIntl} from "@/pages/datalab/utils/utils";
import {buriedPoint} from "@/pages/home/utils/buriedPoint";
const { Content } = Layout;

export default connect((state: any) => ({
  getTableInfoLoading: state.loading.effects[`${namespace}/getTableInfo`],
}))(Extraction);

export function Extraction(props: any) {
  
  const { gameCode } = useSelector((state) => ({gameCode: state.datalab.gameCode}));
  const [curGameCode, setCurGameCode] = useState('');
  const [packageId, setPackageId] = useState<number | undefined>(undefined);

  const package_uuid = props?.location?.query?.package_uuid;
  const packageName = props?.location?.query?.packageName;
  const tableId = props?.location?.query?.tableId;

  // const loading = useMemo(() => getTableInfoLoading, [getTableInfoLoading]);
  useEffect(() => {
    buriedPoint({
      pageId: package_uuid ? '600302' : '600301',
      pageName: package_uuid ? packageName : '号码包提取',
      extInfo: package_uuid ? `{"pageName": "${packageName}", "pageNameCn": "", "id": "${package_uuid}"}` : `{"pageName": "User Extraction", "pageNameCn": "号码包提取", "id": ""}`,
      pagePath: '/Analysis/PacketExtraction',
      uid: gameCode,
      typeId: "datalab_pc_v2",
      menuId: '0',
    });
    
    // 依赖 package_uuid 可以兼容 某个号码包详情编辑状态, 新建号码包状态, 切换游戏业务状态
  }, [package_uuid]);

  useEffect(() => {
    props.dispatch({
      type: `${namespace}/getTableInfo`,
      payload: { package_uuid, gameCode, tableIds: tableId ? [tableId] : [] },
      callback: (packageRsp: any) => {
        if (package_uuid) {
          if (packageRsp) {
            props.dispatch({
              type: `${namespace}/getPackageDetail`,
              payload: {
                response: packageRsp,
              },
            });
          }
        } else {
          props.dispatch({
            type: `${namespace}/save`,
            payload: { saveObj: {}, calculateHashForSave: true },
          });
        }
      },
    });
  }, [package_uuid, tableId]);

  // 切换游戏时，清除数据
  useEffect(() => {
    if (curGameCode === null) {
      setCurGameCode(gameCode);
      return;
    }
    if (curGameCode !== gameCode || packageId !== package_uuid) {
      props.dispatch({
        type: `${namespace}/clearTableInfo`,
      });
      props.dispatch({
        type: `${namespace}/clearQuery`,
      });
      setPackageId(package_uuid);
      setCurGameCode(gameCode);
    }
  }, [gameCode, package_uuid]);

  // const [visible, setVisible] = useState(false);
  const {dblFormatMessage: extractionFormatMessage} = useDblIntl("extraction");
  return (
    <Content>
      <Content.Header title={extractionFormatMessage("title")} />
      <Content.Body full className="datalabe-analysis">
        <Row style={{ height: '100%' }}>
          <Col className="collapse-left">
            <Card className="analysis-number">
              <Card.Body style={{height: "inherit"}}>
                <DataSource />
              </Card.Body>
            </Card>
          </Col>
          <Col className="collapse-right">
            <PackageEdit />
          </Col>
        </Row>
      </Content.Body>
    </Content>
  );
}
